import { render } from "./TaskDetails.vue?vue&type=template&id=135235e7"
import script from "./TaskDetails.vue?vue&type=script&lang=js"
export * from "./TaskDetails.vue?vue&type=script&lang=js"
script.render = render

export default script